import React from "react";
import { WelcomeWrapper } from "./styled";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import AuthFooter from "./AuthFooter";
import {
  Box,
  HeadingStyled,
  HeadingStyledMd,
  HeadingStyledSm,
} from "../styled/Elements";
import { useLocation } from "react-router-dom";

const AuthWelcome = ({ logSignImg, noBorderClass }) => {
  const { t } = useTranslation();
  const location = useLocation();
  return (
    <>
      <Col lg={6} md={6} sm={12} className="px-0 auth-slider authCol">
        <WelcomeWrapper>
          <Box className="welcomeWrapperInner">
            {/* <Box className="welcomHeadTxt">
              {location.pathname !== "/reset-password" &&
                location.pathname !== "/login" && (
                  <HeadingStyledMd
                    size="30px"
                    color="var(--themeColorSecondary)"
                    className="text-center"
                  >
                    {t("WelcomeMembersCommunity")}
                  </HeadingStyledMd>
                )}
            </Box> */}
            <Box className="logSignImgWrapper">
              <Box
                className={`logSignImg ${
                  noBorderClass ? "" : "logSignImgBorder"
                }`}
              >
                <img src={logSignImg} />
              </Box>
            </Box>
            <Box className="welcomHeadTxt">
              {location.pathname !== "/reset-password" && (
                <HeadingStyledMd
                  size="20px"
                  weight="bold"
                  className={`text-center ${location.pathname === "/login" ? "marginBot" : "negMarginBot"}`}
                >
                  {t("Connectcollaborategrow")}
                </HeadingStyledMd>
              )}
            </Box>
          </Box>
          <AuthFooter />
        </WelcomeWrapper>
      </Col>
    </>
  );
};

export default AuthWelcome;
